const UK_STACK = 'UK';
const IRELAND_STACK = 'Ireland';

const stack = process.env.REACT_APP_STACK || UK_STACK;

const isUK = () => stack === UK_STACK;
const isIreland = () => stack === IRELAND_STACK;

const createObjectFromStack = (object, otherObject) => ({
  [UK_STACK]: object,
  [IRELAND_STACK]: otherObject
});

export {
  UK_STACK,
  IRELAND_STACK,
  stack as currentStack,
  createObjectFromStack,
  isIreland,
  isUK
};



// WEBPACK FOOTER //
// ./src/data/stack.js